import { render, staticRenderFns } from "./TextPage.vue?vue&type=template&id=31ec8804"
import script from "./TextPage.vue?vue&type=script&lang=js"
export * from "./TextPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports